import { useState, useRef, useEffect  } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  PointElement,
  Title,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Pie } from 'react-chartjs-2';

ChartJS.register(
  ArcElement,
  Legend,
  CategoryScale,
  PointElement,
  Title,
  Tooltip,
  ChartDataLabels);

ChartJS.defaults.color = "#000000";
ChartJS.defaults.font.size = 28;

const PieChart = ({ pieData }) => {

  const refContainer = useRef();
  const [mainTitleSize, setMainTitleSize] = useState(40);
  const [legendSize, setLegendSize] = useState(18);
  const [dataLabelSize, setDataLabelSize] = useState(20);
  const [boxSize, setBoxSize] = useState(28);


  var data = {
    labels: ['Alimentos (45,3%)', 'Jardins/Rejeitos (14,1%)', 'Papéis (10,4%)', 'Têxteis (5,6%)', 'Madeiras e derivados (1,4%)', 'Outros (23,2%)'],
    datasets: [{
      data: [pieData.quantidade * (45.30 / 100), pieData.quantidade * (14.1 / 100), pieData.quantidade * (10.4 / 100), pieData.quantidade * (5.6 / 100), pieData.quantidade * (1.4 / 100), pieData.quantidade * (23.2 / 100)],
      backgroundColor: [
        '#bf9000',
        '#0F77BD',
        '#ff0000',
        '#a71eb2',
        '#00aa00',
        '#999999'
      ],
      borderColor: [
        '#bf9000',
        '#0F77BD',
        '#ff0000',
        '#a71eb2',
        '#00aa00',
        '#999999'
      ],
      borderWidth: 1,

    }]
  };


  var options = {
    responsive: true,
    maintainAspectRation: false,
    interaction: {
      mode: null
    },
    responsive: true,
    plugins: {
      locale: 'pt-br',
      datalabels: {
        backgroundColor: function (context) {
          return context.dataset.backgroundColor;
        },
        borderColor: 'white',
        borderRadius: 20,
        borderWidth: 1,
        color: 'white',
        font: {
          weight: 'bold',
          size: dataLabelSize
        },
        padding: 6,
        formatter: ((context, args) => {
          const index = args.dataIndex;
          return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(args.chart.data.datasets[0].data[index])
        }
        ),
        clamp: true,
        anchor: 'end',
        offset: 200,
      },
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: legendSize,
            weight: 'bold'
          },
          boxHeight: boxSize,
          boxWidth: boxSize,
          padding: 20,
          color: '#1E3050'
        },
      },
      title: {
        display: true,
        color: '#246676',
        text: 'Total em ' + pieData.ano + " (t)",
        font: {
          size: mainTitleSize,
          weight: 900
        },
        padding: {
        }
      },
      subtitle: {
        display: true,
        text: 'Aterro Sanitário - Central de Resíduos do Recreio, Minas do Leão/RS'
      }
    }
  }
    return (
      <div className={'fixed bg-stone-300 my-0  m-auto  left-[25vw] top-[10vh] w-[50vw] h-[85vh] z-10 rounded-2xl'}>
        <Pie
          data={data}
          options={options}
          ref={refContainer}
        />
      </div>
    )
}

export default PieChart